import { waUrl } from "@/lib/whatsapp";

export const FloatingWhatsApp = () => (
  <a
    href={waUrl()}
    target="_blank"
    rel="noopener noreferrer"
    className="wa-float"
    data-track="flotante-whatsapp"
    data-testid="floating-whatsapp-button"
    aria-label="Hablar con Richard Gower por WhatsApp"
  >
    <span className="wa-float-icon"><i className="fab fa-whatsapp" /><span className="wa-float-dot" /></span>
    <span className="wa-float-text">Hablar con Richard Gower<small>Respuesta rápida · Alta express en minutos</small></span>
  </a>
);

export default FloatingWhatsApp;
